import React from 'react';
import axios from "../../../containers/api";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import {Alert, Button, Card, CardBody, FormGroup, Input, InputGroup, InputGroupAddon, Label, Row} from "reactstrap";
import {showCatchError, toEnglishNumbers} from "../../../helpers/Utils";

class AddAdminUser extends React.Component {
    state = {
        userName: "",
        password: "",
        repassword: "",
        fullName: "",
        Email: "", 
        errors: [],
        Type: this.props && this.props.Type.type,
    };

    validateInputData = () => {
        this.props.closeSweetAlert();
        let error = [];
        if (this.state.fullName && this.state.fullName.trim() === null || this.state.fullName.trim() === "") {
            error.push("وارد كردن نام و نام خانوادگي الزامی میباشد");
        }
        if (this.state.Email && this.state.Email.trim() === null || this.state.Email.trim() === "") {
            error.push("وارد كردن ایمیل الزامی میباشد");
        }
        if (this.state.userName && this.state.userName.trim() === null || this.state.userName.trim() === "") { 
            error.push("وارد كردن نام كاربری الزامی میباشد");
        }
        if (this.state.userName && this.state.userName.length < 10) { 
            error.push("نام کاربری باید حداقل 10 حرف ياشد");
        }
        if (this.state.password && this.state.password.trim() === null || this.state.password.trim() === "" || this.state.password.length < 6) {
            error.push("رمز عبور باید حداقل 6 حرف ياشد");
        }
        if (this.state.repassword && this.state.repassword.trim() === null || this.state.repassword.trim() === "") { 
            error.push("وارد كردن تکرار رمز عبور الزامی میباشد");
        }
        
        if (this.state.password !== this.state.repassword) {
            error.push('رمز عبور و تکرار رمز عبور باید یکسان باشند');
        }

        this.setState({errors: error});
        if (error.length === 0) {
            this.submitForm();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    submitForm = () => {
        const addModel = {
            UserName: toEnglishNumbers(this.state.userName).toString(),
            Password: this.state.password,
            Email: this.state.Email,
            Fullname: toEnglishNumbers(this.state.fullName), 
            Type: toEnglishNumbers(this.state.Type), 
            
        };

        this.props.showSpinner();
        axios.post('/api/v1/User/signup', addModel) 
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.statusCode === 200) {
                    this.props.showAlert("ثبت کاربر جدید با موفقیت انجام شد!", "success");
                } else {
                    this.props.showAlert(res.data.errors, "error");
                }
            })
            .catch((error) => {
                console.log(error)
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
            });
    }

    render() {
        return (
            <>
                

                 

                <Row className="d-flex justify-content-center">
                    <Colxx md="10" xxs="12">
                        <CardBody>
                            <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                                <FormGroup className="w-md-25 w-100 px-1">
                                    <Label>*نام کاربری</Label>
                                    <InputGroup className="mb-3">
                                        <Input value={this.state.userName} maxLength={50}
                                            onChange={(e) => this.setState({ userName: e.target.value.replace(/[^0-9۰-۹]/g, "") })} />
                                        <InputGroupAddon addonType="append">
                                            <span className="input-group-text">
                                                {(this.state.Type === 5 || this.state.Type === "5") ? "OR" : (this.state.Type === 6 || this.state.Type === "6") ? "DA" : (this.state.Type === 7 || this.state.Type === "7") ? "ATC" : ""}
                                            </span>
                                        </InputGroupAddon>
                                    </InputGroup>
                                </FormGroup>

                                <FormGroup className="w-md-25 w-100 px-1">
                                    <Label>نام و نام خانوادگی</Label>
                                    <Input value={this.state.fullName} maxLength={50} 
                                        onChange={(e) => this.setState({ fullName: e.target.value })} />
                                </FormGroup>
                               
                            </div>
                            <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                                <FormGroup className="w-md-25 w-100 px-1">
                                    <Label>*رمز عبور</Label>
                                    <Input value={this.state.password} maxLength={50} type="password"
                                        onChange={(e) => this.setState({ password: e.target.value })} />
                                </FormGroup>
                                <FormGroup className="w-md-25 w-100 px-1">
                                    <Label>*تکرار رمز عبور</Label>
                                    <Input value={this.state.repassword} maxLength={50} type="password"
                                        onChange={(e) => this.setState({ repassword: e.target.value })} />
                                </FormGroup>
                            </div>
                            <div className="d-flex flex-md-row flex-column flex-wrap justify-content-center mt-3">
                                <FormGroup className="w-md-25 w-100 px-1">
                                    <Label>*ایمیل</Label>
                                    <Input value={this.state.Email} maxLength={50}
                                        onChange={(e) => this.setState({ Email: e.target.value })} />
                                </FormGroup>
                                <FormGroup className="w-md-25 w-100 px-1">
                                   
                                </FormGroup>
                            </div>
                            {this.state.errors.length === 0 ?
                                null
                                :
                                <div className="w-75">
                                    {(this.state.errors.map((error, i) => {
                                        return (
                                            <Alert color="danger" key={i}>{error}</Alert>
                                        )
                                    }))}
                                </div>
                            }
                            <div className="d-flex mt-2 justify-content-center">
                                <FormGroup className="text-center">
                                    <Button color="primary" className="btn-lg mx-2" onClick={() => this.props.showSweetAlert("", "آیا از صحت اطلاعات وارد شده اطمینان دارید؟", "warning", this.validateInputData)}>
                                        ثبت
                                    </Button>
                                </FormGroup>
                            </div>
                            
                        </CardBody>
                    </Colxx>
                </Row>

            </>

        )

    }
}

export default AddAdminUser;